// Converted SignalRContext.jsx bez recoil - ispravljena ESLint upozorenja
import React, {
  createContext,
  useEffect,
  useState,
  useContext,
  useRef,
} from 'react';
import * as signalR from '@microsoft/signalr';
import { find } from 'lodash';
import axios from 'axios';

export const ChatContext = createContext({
  messages: [],
  setMessages: () => {},
  searchMessageId: null,
  setSearchMessageId: () => {},
  signalRConnection: null,
  initializeSignalRConnection: () => {},
  conversations: [],
  setConversations: () => {},
  conversationId: null,
  setConversationId: () => {},
  setMessagesRaw: () => {},
  unreadedMessages: 0,
  setUnreadedMessages: () => {},
});

export const useChatContext = () => useContext(ChatContext);

export const ChatProvider = ({ children, brojPoruka, setBrojPoruka }) => {
  const previousMessagesRef = useRef(null);
  const [messages, setMessages] = useState([]);
  const [unreadedMessages, setUnreadedMessages] = useState(44);
  const [signalRConnection, setSignalRConnection] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [token, setToken] = useState(null);
  const [searchMessageId, setSearchMessageId] = useState(null);
  const [conversationId, setConversationId] = useState(null);
  const apiBaseUrl = 'https://cloud3.okta.rs:20044';
  const loggedInUserId = localStorage.getItem('idKorisnika');

  const convertStringToList = (str) =>
    str
      .replace(/[[\]\s]/g, '')
      .split(',')
      .map((item) => item.trim());

  useEffect(() => {
    console.log('setBrojPoruka', brojPoruka);
  }, [brojPoruka]);

  const handleUnreadMessages = (msg) => {
    setBrojPoruka(msg.brojNeProcitanihPoruka);
    // window.parent.postMessage(
    //   { unreadedNumber: msg.brojNeProcitanihPoruka },
    //   'http://localhost:3000/',
    // );
  };
  useEffect(() => {
    console.log('NEPROCITANE', unreadedMessages);
  }, [unreadedMessages]);

  const initializeSignalRConnection = () => {
    // if (
    //   localStorage.getItem('noviToken') !== 'true' ||
    //   !token ||
    //   signalRConnection
    // ) {
    //   console.log('ULAZI U RETURN');
    //   return;
    // }
    console.log(signalRConnection);
    const newConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${apiBaseUrl}/chatHub`, {
        accessTokenFactory: () =>
          token || Promise.reject(new Error('No token found')),
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    newConnection.on('receivemessage', (msg) => {
      console.log('📩 stigla poruka odmah:', msg);
      if (msg?.oznakaSignal === 'unread_count') {
        handleUnreadMessages(msg);
      }
    });

    setSignalRConnection(newConnection);

    newConnection.onclose((error) => {
      console.error('⚠️ SignalR konekcija zatvorena:', error);
    });

    newConnection
      .start()
      .then(() => {
        localStorage.setItem('noviToken', 'false');
        console.log('Connection state:', newConnection.state);
      })
      .catch((err) => console.error('Connection failed:', err));
  };

  const messageHandler = (message) => {
    if (String(message.conversationId) === String(conversationId)) {
      setMessages((prev) => {
        const existing = prev?.messages || [];

        const alreadyExists = existing.find((m) => m.id === message.id);
        if (alreadyExists) {
          // update body poruke
          const updatedMessages = existing.map((m) =>
            m.id === message.id
              ? {
                  ...m,
                  body: message.body,
                  izmena: message.izmena,
                  oznaka: message.oznaka,
                }
              : m,
          );

          return {
            ...prev,
            messages: updatedMessages,
          };
        }

        return {
          ...prev,
          messages: [...existing, message],
        };
      });
    }
  };

  const updateHandler = (messages) => {
    setMessages((prev) => {
      const existingMessages = prev?.messages || [];
      const updatedMessages = messages.filter(
        (message) =>
          !existingMessages.some(
            (m) =>
              m.id === message.id &&
              JSON.stringify(m) === JSON.stringify(message),
          ),
      );

      if (updatedMessages.length > 0) {
        const mergedMessages = existingMessages.map((m) => {
          const updatedMessage = updatedMessages.find((msg) => msg.id === m.id);
          return updatedMessage || m;
        });

        return {
          ...prev,
          messages: mergedMessages,
        };
      }

      return prev;
    });
  };

  useEffect(() => {
    console.log('Promene', conversations);
  }, [conversations]);

  const newHandlerConversation = (msg) => {
    console.log('msg', msg);

    setConversations((prev) => {
      const existsIndex = prev.findIndex(
        (c) => String(c.id) === String(msg.id),
      );

      if (existsIndex !== -1) {
        // Ažuriraj samo ime ako se promenilo
        const updated = [...prev];
        updated[existsIndex] = {
          ...updated[existsIndex],
          name: msg.name || updated[existsIndex].name,
        };
        return updated;
      }

      // Nova konverzacija
      const transformedConversation = {
        id: msg.id,
        name: msg.name || '',
        isGroup: msg.isGroup || false,
        logo: msg.logo || '',
        createdAt: msg.createdAt,
        oznaka: msg.oznaka,
        lastMessageAt: msg.lastMessageAt || msg.createdAt,
        users: msg.users.map((u) => ({
          userId: u.id,
          conversationId: msg.id,
          user: u,
        })),
        messages: [],
        messagesIds: [],
        seenIds: [],
        poslednjaOznaka: msg.poslednjaOznaka ?? null,
      };

      console.log('convMSG', transformedConversation);
      return [transformedConversation, ...prev];
    });
  };

  const updateHandlerConversation = async (data) => {
    console.log('NENAD2', conversations);

    setConversations((prev) => {
      const updatedList = prev.map((conversation) => {
        if (String(conversation.id) === String(data.id)) {
          const lastMsg = data.messages[data.messages.length - 1];
          const dataTime = new Date(lastMsg.createdAt);
          const messages = conversation?.messages || [];
          const messagesIds = conversation?.messagesIds || [];
          let lastMessageAt = conversation?.lastMessageAt;

          // Ako poruka već postoji (po ID), preskoči update
          const alreadyExists = messages.some((m) => m.id === lastMsg.id);
          if (alreadyExists) {
            return {
              ...conversation,
              messages: messages.map((m, idx) => {
                // ako je poslednji element i ima seenIds -> update
                if (idx === messages.length - 1 && m.seenIds !== undefined) {
                  return {
                    ...m,
                    seenIds: lastMsg.seenIds,
                  };
                }
                return m;
              }),
              seenIds: lastMsg.seenIds,
            };
          }

          try {
            lastMessageAt =
              lastMessageAt?.getTime() > dataTime.getTime()
                ? lastMessageAt
                : dataTime;
          } catch {
            lastMessageAt = dataTime;
          }
          // Ne diraj lokalni TESTIRANJE (sesija traje dok korisnik ne napusti chat)
          const currentOznaka = localStorage.getItem('oznaka');
          const hasLocalTestiranje =
            String(currentOznaka || '').toUpperCase() === 'TESTIRANJE';
          const incomingOznaka = lastMsg?.oznaka;
          const isValidIncoming =
            incomingOznaka &&
            incomingOznaka !== 'null' &&
            incomingOznaka !== 'undefined' &&
            String(incomingOznaka).toUpperCase() !== 'TESTIRANJE';

          if (!hasLocalTestiranje) {
            localStorage.setItem(
              'oznaka',
              isValidIncoming ? incomingOznaka : 'null',
            );
          }
          return {
            ...conversation,
            messages: [...messages, lastMsg],
            messagesIds: [...messagesIds, lastMsg.id],
            lastMessageAt,
            seenIds: convertStringToList(lastMsg.seenIds),
            // obična oznaka prati poslednju poruku; TESTIRANJE se nikad ne deli drugim korisnicima
            poslednjaOznaka: isValidIncoming ? incomingOznaka : null,
          };
        }

        return conversation;
      });

      return updatedList.sort((a, b) => {
        const aTime = new Date(a?.lastMessageAt || a.createdAt);
        const bTime = new Date(b?.lastMessageAt || b.createdAt);
        return bTime.getTime() - aTime.getTime();
      });
    });

    return null; // <- eksplicitni return za eslint
  };

  const deleteHandlerConversation = (data) => {
    setConversations((prev) => prev.filter((conv) => conv.id !== data.id));
  };

  const updateSeen = async (data) => {
    try {
      console.log('SEEN_POZIV');
      await axios.post(`${apiBaseUrl}/api/Messages/seen`, {
        conversationId: +data.id,
        userId: loggedInUserId,
      });
    } catch (err) {
      console.warn('Greška pri označavanju kao viđeno:', err);
    }
  };
  const parseSeenIds = (input) => {
    if (Array.isArray(input)) return input;
    if (typeof input === 'string') {
      try {
        return JSON.parse(input);
      } catch {
        return [];
      }
    }
    return [];
  };

  useEffect(() => {
    if (!signalRConnection) return undefined; // eksplicitno vratiti undefined

    const handler = (msg) => {
      console.log('Message received from server:', msg);

      switch (msg.oznakaSignal) {
        case 'new_message':
          messageHandler(msg);
          break;

        case 'message_seen':
          (async () => {
            try {
              const response = await axios.post(
                `${apiBaseUrl}/api/Messages/seen_update`,
                { id: +msg.id },
              );
              if (response.status === 200) updateHandler(response.data);
            } catch (error) {
              console.error('Error during API call:', error);
            }
          })();
          break;

        case 'new_group':
          newHandlerConversation(msg);
          break;
        case 'update_conversation': {
          updateHandlerConversation(msg);

          const lastMsg = msg.messages?.[msg.messages.length - 1];
          const seenIds = parseSeenIds(lastMsg?.seenIds);
          const alreadySeenByMe = seenIds.includes(+loggedInUserId);
          const isMyMessage = lastMsg?.userId === +loggedInUserId;

          // ✅ Pozovi updateSeen samo ako gledam aktivni chat
          if (
            String(msg.id) === String(conversationId) &&
            !alreadySeenByMe &&
            !isMyMessage
          ) {
            updateSeen(msg);
          }

          break;
        }

        case 'delete_group':
          deleteHandlerConversation(msg);
          break;

        case 'unread_count':
          handleUnreadMessages(msg);
          break;

        default:
          console.warn('Unknown message type:', msg.oznakaSignal);
      }
    };

    signalRConnection.on('receivemessage', handler);

    return () => {
      signalRConnection.off('receivemessage', handler);
    };
  }, [signalRConnection, conversationId]);

  useEffect(() => {
    const storedToken = localStorage.getItem('chatToken');
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  useEffect(() => {
    if (token) {
      initializeSignalRConnection();
    }
  }, [token]);

  return (
    <ChatContext.Provider
      value={{
        messages,
        setMessages,
        searchMessageId,
        setSearchMessageId,
        setMessagesRaw: setMessages,
        signalRConnection,
        initializeSignalRConnection,
        conversations,
        setConversations,
        conversationId,
        setConversationId,
        unreadedMessages,
        setUnreadedMessages,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
